import { LocaleService } from '../_services/locale.service';
import * as i0 from "@angular/core";
import * as i1 from "../_services/locale.service";
export class ServicesDataProvider {
    constructor(localeService) {
        this.localeService = localeService;
        this.services = [];
        this.orphans = [];
        this.translatedServices = [];
        this.translatedOrphanServices = [];
    }
    setServices(services) {
        if (!Array.isArray(services)) {
            this.services = [];
        }
        else {
            this.services = services;
        }
        return this;
    }
    addService(service) {
        this.services.push(service);
        return this;
    }
    addServices(services) {
        this.services = this.services.concat(services);
        return this;
    }
    getServices() {
        return this.services;
    }
    getService(id) {
        if (this.services.length == 0) {
            return;
        }
        return this.services.find(service => service.id === id);
    }
    getTranslatedServices() {
        this.translatedServices = [];
        if (!Array.isArray(this.services)) {
            return [];
        }
        else {
            this.services.forEach(service => {
                const translatedService = this.translateService(service);
                if (translatedService) {
                    this.translatedServices.push(translatedService);
                }
            });
        }
        return this.translatedServices;
    }
    getTranslatedService(id) {
        if (this.services.length == 0) {
            return;
        }
        return this.translateService(this.getService(id));
    }
    translateService(service) {
        if (!service) {
            return;
        }
        let translatedService = Object.assign({}, service);
        let locale = this.localeService.getLocale();
        if (Array.isArray(translatedService.translations) && translatedService.translations.length > 0) {
            let localeTranslation = translatedService.translations.find((translation) => translation.locale === locale);
            if (localeTranslation) {
                translatedService.name = localeTranslation.name;
                translatedService.description = localeTranslation.description;
            }
        }
        return translatedService;
    }
    setOrphanServices(orphans) {
        if (!Array.isArray(orphans)) {
            this.orphans = [];
        }
        else {
            this.orphans = orphans;
        }
        return this;
    }
    getOrphanServices() {
        return this.orphans;
    }
    getOrphanTranslatedServices() {
        this.translatedOrphanServices = [];
        if (!Array.isArray(this.orphans)) {
            return [];
        }
        this.orphans.forEach(service => {
            const translatedService = this.translateService(service);
            if (translatedService) {
                this.translatedOrphanServices.push(translatedService);
            }
        });
        return this.translatedOrphanServices;
    }
}
ServicesDataProvider.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ServicesDataProvider_Factory() { return new ServicesDataProvider(i0.ɵɵinject(i1.LocaleService)); }, token: ServicesDataProvider, providedIn: "root" });
